import { useQuery } from "@tanstack/react-query";
import { customInstance } from "@/api/axios-instance";
import type { SlicingModelInfo } from "@/api/pizza-checker/schemas";

/**
 * Slicing result of a pizza: the stored metadata.slicing_model when the evaluation has one, otherwise the
 * backend computes it on demand from the stored photo + crust mask (GET /api/admin/pizzas/{id}/slicing:
 * no GPU, nothing persisted). Only fetched when `enabled` (the slicing layer is shown).
 */
export function usePizzaSlicing(
  pizzaId: string | null | undefined,
  stored: SlicingModelInfo | null | undefined,
  enabled: boolean,
) {
  const query = useQuery({
    queryKey: [`/api/admin/pizzas/${pizzaId}/slicing`],
    queryFn: ({ signal }) =>
      customInstance<SlicingModelInfo>({ url: `/api/admin/pizzas/${pizzaId}/slicing`, method: "GET", signal }),
    enabled: enabled && !!pizzaId && !stored,
    staleTime: 10 * 60 * 1000,
    retry: false,
  });
  return {
    slicing: stored ?? query.data ?? null,
    loading: !stored && query.isFetching,
    error: !stored && query.isError,
  };
}
